export const NO_SERIAL = ''

export function effectiveSerialNumbers(serialNumbers: readonly string[]): string[] {
  return serialNumbers.length ? [...serialNumbers] : [NO_SERIAL]
}
